angular.module('app.factories').factory('selectize', ($rootScope, $translate, $compile, $templateCache, api, notify) => {
    const templates = {
        default: {
            create: false,
            maxItems: 1,
            placeholder: $translate.instant('choose'),
            optgroupField: 'parent_id',
            optgroupValueField: 'id',
            optgroupLabelField: 'title',
            valueField: 'value',
            labelField: 'label',
            searchField: 'label',
        },
    };

    const selectize = {
        createConfig(overrides) {},

        createConfigFromTemplate(templateName, overrides) {
            const config = templates[templateName] || {};

            if (config.include) {
                angular.forEach(config.include, (templateToInclude) => {
                    angular.extend({}, config, templates[templateToInclude] || {});
                });
            }

            return angular.extend({}, config, overrides || {});
        },

        createConfigFromDefault(overrides) {
            return this.createConfigFromTemplate('default', overrides);
        },

        createAjaxConfig(path, overrides) {
            const ajax = {
                valueField: 'id',
                labelField: 'name',
                searchField: 'name',
                load(query, callback) {
                    if (!query.length) {
                        return callback();
                    }

                    $.ajax({
                        url: `/api/1/${path}`,
                        type: 'GET',
                        data: {
                            query,
                        },
                        error() {
                            callback();
                        },
                        success(res) {
                            callback(res.slice(0, 10));
                        },
                    });
                },
            };

            return angular.extend({}, templates.default, ajax, overrides || {});
        },

        initConfig() {
            if ('undefined' !== typeof $rootScope.selectize_config) {
                return false;
            }

            $rootScope.selectize_config = selectize.createConfigFromDefault();

            $rootScope.selectize_config_multi = selectize.createConfigFromDefault({
                maxItems: 999,
            });

            $rootScope.selectize_config_client_readonly = selectize.createAjaxConfig('select/clients', {
                searchField: ['name', 'address'],
                render: {
                    option(data, escape) {
                        return `<div>
							<span>${escape(data.name)}</span><br>
							${data.address ? `<span class="uk-text-muted uk-text-small">${escape(data.address)}</span>` : ''}
						</div>`;
                    },
                },
                persist: false,
                create: false,
            });

            $rootScope.selectize_config_client = angular.extend({}, $rootScope.selectize_config_client_readonly, {
                searchField: ['name', 'address'],
                render: {
                    option(data, escape) {
                        return `<div>
							<span>${escape(data.name)}</span><br>
							${data.address ? `<span class="uk-text-muted uk-text-small">${escape(data.address)}</span>` : ''}
						</div>`;
                    },
                    option_create(data, escape) {
                        return `<div class="create">${$translate.instant('add')}: &nbsp; <strong>${escape(data.input)}</strong>&hellip;</div>`;
                    },
                },
                persist: true,
                create(input) {
                    const selectize = this;
                    const newName = input.replace(/^\s+|\s+$/, '');

                    const newClient = {
                        id: -1,
                        name: newName,
                    };

                    if (!newClient) {
                        return false;
                    }

                    let container = $('.add-client-form');
                    if (!container.length) {
                        const html = $templateCache.get('/directives/client/quick_add_client.html');
                        const clientScope = $rootScope.$new(true);

                        clientScope.name = input;
                        clientScope.saveClient = () => {
                            clientScope.name = clientScope.name.replace(/^\s+|\s+$/);

                            if (clientScope.name.length < 2) {
                                notify.danger($translate.instant('clients.wrong_name'));
                                return false;
                            }
                            const ClientModel = api('clients');
                            const info = notify.info($translate.instant('saving'));

                            const clientData = {
                                name: clientScope.name,
                                email: clientScope.email,
                                phone: clientScope.phone,
                            };

                            notify.global(1);

                            ClientModel.save(0, clientData).then(
                                (response) => {
                                    ClientModel.clearCache();

                                    info.close();
                                    notify.success($translate.instant('saved'));
                                    notify.global(0);

                                    selectize.updateOption(-1, {
                                        id: response.id,
                                        name: response.name,
                                    });
                                    selectize.trigger('change');
                                    UIkit.modal('#quick-add-client').hide();
                                },
                                () => {
                                    selectize.removeOption(-1);
                                    selectize.clear();
                                    UIkit.modal('#quick-add-client').hide();
                                }
                            );
                        };
                        container = $('<div class="add-client-form"/>').html($compile(html)(clientScope));
                        $('body').append(container);
                    }
                    UIkit.modal('#quick-add-client').show();

                    return newClient;
                },
            });

            $rootScope.selectize_config_interests = selectize.createAjaxConfig('select/interests', {
                searchField: ['name', 'client'],
                render: {
                    option(data, escape) {
                        return ['<div>', '<span>', escape(data.name), '</span><br>', '<span class="uk-text-muted uk-text-small">', escape(data.client), '</span>', '</div>'].join(
                            ''
                        );
                    },
                },
            });

            $rootScope.selectize_config_projects = selectize.createAjaxConfig('select/projects', {
                searchField: ['name', 'client'],
                render: {
                    option(data, escape) {
                        return [
                            '<div>',
                            '<span>',
                            escape(data.symbol),
                            ': ',
                            escape(data.name),
                            '</span><br>',
                            '<span class="uk-text-muted uk-text-small">',
                            escape(data.client),
                            '</span>',
                            '</div>',
                        ].join('');
                    },
                },
            });
        },
    };

    return selectize;
});
